<template>
  <v-expansion-panel>
    <v-expansion-panel-title v-slot="{ expanded }">
      <v-row no-gutters>
        <v-col cols="4" class="text-primary "> Bon d'Installation </v-col>
        <v-col cols="8" class="text-medium-emphasis">
          <v-fade-transition leave-absolute>
            <span v-if="expanded" key="edit"> Editer le bon puis sauvegarder </span>
            <div v-else key="summary">
              <div v-if="bonInstallation.account">
                {{ bonInstallation.account.name }}
              </div>
              <div v-if="bonInstallation.laverie">
                / {{ bonInstallation.laverie.name }}
              </div>
            </div>
          </v-fade-transition>
        </v-col>
      </v-row>
    </v-expansion-panel-title>
    <v-expansion-panel-text>
      <v-row no-gutters>
        <v-spacer></v-spacer>
        <v-col cols="6">
          <v-autocomplete v-model="bonInstallation.account" :items="accounts" item-title="name" return-object label="Siège"></v-autocomplete>
        </v-col>
        <v-divider vertical class="mx-4"></v-divider>
        <v-col cols="3">
          <br />
          Choisissez le compte siège
        </v-col>
      </v-row>
      <v-row v-if="bonInstallation.account" no-gutters>
        <v-spacer></v-spacer>
        <v-col cols="6">
          <v-autocomplete v-model="bonInstallation.laverie" :items="laveries" item-title="name" return-object
            label="Laverie"></v-autocomplete>
        </v-col>
        <v-divider vertical class="mx-4"></v-divider>
        <v-col cols="3">
          <br />
          Choisissez la laverie
        </v-col>
      </v-row>
      <template v-if="bonInstallation.laverie && bonInstallation.laverie.address">
        <v-row no-gutters>
          <v-spacer></v-spacer>
          <v-col cols="1" class="pr-1">
            <v-text-field v-model="bonInstallation.laverie.address.numero" name="numero" hint="Le numéro dans la rue"
               label="Numero">
            </v-text-field>
          </v-col>
          <v-col cols="5" class="pl-1">
            <v-text-field name="rue" hint="Le nom de la rue" v-model="bonInstallation.laverie.address.rue"
               label="Rue">
            </v-text-field>
          </v-col>
          <v-divider vertical class="mx-4"></v-divider>
          <v-col cols="3">
            <br />
            Changez l'adresse si nécessaire
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-spacer></v-spacer>
          <v-col cols="1" class="pr-1">
            <v-text-field name="codepostale" hint="Le code postale de la ville"
              v-model="bonInstallation.laverie.address.codepostale"  label="Code Postale">
            </v-text-field>
          </v-col>
          <v-col cols="5" class="pl-1">
            <v-text-field name="ville" hint="Le nom de la ville" v-model="bonInstallation.laverie.address.ville"
               label="Ville">
            </v-text-field>
          </v-col>
          <v-divider vertical class="mx-4"></v-divider>
          <v-col cols="3"> </v-col>
        </v-row>
      </template>
      <template v-if="bonInstallation.laverie">
        <v-row no-gutters>
          <v-spacer></v-spacer>
          <v-col cols="6">
            <v-text-field name="acces" v-model="bonInstallation.laverie.codeAcces" 
              label="Accès">
            </v-text-field>
          </v-col>
          <v-divider vertical class="mx-4"></v-divider>
          <v-col cols="3">
            <br />
            Détaillez l'accessibilité
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-spacer></v-spacer>
          <v-col cols="6">
            <v-text-field v-model="bonInstallation.installDate" type="date">
              <template #label>
                Date d'installation<span class="text-red"><strong> *</strong></span>
              </template>
            </v-text-field>
          </v-col>
          <v-divider vertical class="mx-4"></v-divider>
          <v-col cols="3">
            <br />
            Choisissez la date d'installation
          </v-col>
        </v-row>
      </template>
      <template v-if="bonInstallation.installDate">
        <v-row no-gutters>
          <v-spacer></v-spacer>
          <v-col cols="6">
            <v-text-field name="gestionnaire" hint="Nom et prénom du gestionnaire"
              v-model="bonInstallation.laverie.gestionnaire"  label="Gestionnaire">
            </v-text-field>
          </v-col>
          <v-divider vertical class="mx-4"></v-divider>
          <v-col cols="3">
            <br />
            Changez le gestionnaire si nécessaire
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-spacer></v-spacer>
          <v-col cols="3" class="pr-1">
            <v-text-field name="mobile" v-model="bonInstallation.laverie.telephonePrincipal"
               label="Mobile">
            </v-text-field>
          </v-col>
          <v-col cols="3" class="pl-1">
            <v-text-field name="telephone" v-model="bonInstallation.laverie.telephoneAutre" 
              label="Téléphone">
            </v-text-field>
          </v-col>
          <v-divider vertical class="mx-4"></v-divider>
          <v-col cols="3"> </v-col>
        </v-row>
        <v-row no-gutters>
          <v-spacer></v-spacer>
          <v-col cols="6">
            <v-text-field name="contactSecondPrenom" hint="Nom et prénom du contact secondaire"
              v-model="bonInstallation.contactSecond.name"  label="Autre contact">
            </v-text-field>
          </v-col>
          <v-divider vertical class="mx-4"></v-divider>
          <v-col cols="3">
            <br />
            Renseignez un contact secondaire
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-spacer></v-spacer>
          <v-col cols="3" class="pr-1">
            <v-text-field name="contactSecondMobile" hint="Mobile du contact secondaire"
              v-model="bonInstallation.contactSecond.mobile"  label="Mobile">
            </v-text-field>
          </v-col>
          <v-col cols="3" class="pl-1">
            <v-text-field name="contactSecondTel" hint="Téléphone du contact secondaire"
              v-model="bonInstallation.contactSecond.telephone"  label="Téléphone">
            </v-text-field>
          </v-col>
          <v-divider vertical class="mx-4"></v-divider>
          <v-col cols="3"> </v-col>
        </v-row>
        <v-row no-gutters>
          <v-spacer></v-spacer>
          <v-col cols="6">
            <v-text-field name="contactSecondFonction" hint="Fonction technique du contact secondaire"
              v-model="bonInstallation.contactSecond.fonction"  label="Fonction">
            </v-text-field>
          </v-col>
          <v-divider vertical class="mx-4"></v-divider>
          <v-col cols="3"> </v-col>
        </v-row>
        <v-row no-gutters>
          <v-spacer></v-spacer>
          <v-col cols="6">
            <v-autocomplete v-model="bonInstallation.installedBy" :items="users" item-title="fullName" return-object
              label="Installé par"></v-autocomplete>
          </v-col>
          <v-divider vertical class="mx-4"></v-divider>
          <v-col cols="3">
            <br />
            Choisissez le technicien
          </v-col>
        </v-row>
      </template>

      <v-row v-if="bonInstallation.installedBy" no-gutters>
        <v-spacer></v-spacer>
        <v-col cols="2" class="pr-1">
          <v-text-field name="cleCaisse" v-model="bonInstallation.cleCaisse" 
            label="Clé caisse">
          </v-text-field>
        </v-col>
        <v-col cols="2" class="px-1">
          <v-text-field name="cleTrappe" v-model="bonInstallation.cleTrappe" 
            label="Clé trappe">
          </v-text-field>
        </v-col>
        <v-col cols="2" class="pl-1">
          <v-text-field name="autreCle" v-model="bonInstallation.autreCle" 
            label="Autre clé">
          </v-text-field>
        </v-col>
        <v-divider vertical class="mx-4"></v-divider>
        <v-col cols="3">
          <br />
          Renseignez les clés remises
        </v-col>
      </v-row>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="onCancel" text color="red"> Cancel </v-btn>
        <generate-doc-btn :filePath="bonInstallationTemplatePath" :fileName="bonInstallationFileName"
          :dataSet="bonInstallationGen">Save</generate-doc-btn>
      </v-card-actions>
    </v-expansion-panel-text>
  </v-expansion-panel>
</template>

<script setup lang="ts">
import { ref, computed, watch } from "vue";
import GenerateDocBtn from "@/components/GenerateDocBtn.vue";
import type { User } from "@/types";
import { BonInstallation } from "@/types";
import type { Account } from "@/types";
import type { Laverie } from "@/types";
import { getLaveriesByAccountId } from "@/utils/laverie-api";
import { flattenBonInstallation } from "@/types";

interface Props {
  accounts: Account[];
  users: User[];
}

const props = defineProps<Props>();

// Reactive state
const bonInstallation = ref<BonInstallation>({
  contactSecond: {} as User,
} as BonInstallation);

const bonInstallationGen = computed(() =>
  flattenBonInstallation(bonInstallation.value)
);
const laveries = ref<Laverie[]>([]);

// Computed properties
const bonInstallationTemplatePath = "templates/BonInstallationTemplate.docx";

const bonInstallationFileName = computed(() => {
  if (bonInstallation.value.laverie) {
    return "BonDInstallation_".concat(bonInstallation.value.laverie.name);
  }
  return "BonDInstallation";
});

watch(
  () => bonInstallation.value.account,
  async (selectedAccount) => {
    if (!selectedAccount) return;

    // Reset selected laverie
    bonInstallation.value.laverie = null;
    laveries.value = [];

    await fetchLaveries(selectedAccount.id);
  }
);

const fetchLaveries = async (accountId: string) => {
  try {
    laveries.value = await getLaveriesByAccountId(accountId);
  } catch (error) {
    console.error("Error fetching laveries:", error);
    laveries.value = [];
  }
};

const onCancel = () => {
  // TODO clear form
  bonInstallation.value = {
    contactSecond: {} as User,
  } as BonInstallation;
  laveries.value = [];
};
</script>
